import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_BASE_URL } from '../../environments/environment';
import { ISimulacionDTO } from '../entity-models/simulacionDTO.model';
import { Observable } from 'rxjs';
import { ConfiguracionInicialDTO } from '../entity-models/configuracionInicialDTO.model';
import { ISimulacion } from '../entity-models/simulacion.model';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    constructor(private httpClient: HttpClient) { }

    login() {
        let data = {
            email: 'asd@asd.com',
            password: ''
        };
        this.httpClient.post('/api/login', data).subscribe(
            res => {
                console.log('RESPUESTA: ' + res);
            }
        );
    }

    getConfiguracion(): Observable<HttpResponse<ConfiguracionInicialDTO>> {
        return this.httpClient.get<ConfiguracionInicialDTO>(
            `${API_BASE_URL}/api/getConfiguracionInicial`,
            { observe: 'response' }
        );
    }

    printSimulacion(id: number): Observable<any> {
        return this.httpClient.get<any>(
            `${API_BASE_URL}/api/simulacions/print/${id}`,
            { observe: 'response', responseType: 'blob' as 'json' }
        );
    }
    sendEmail(id: number): Observable<any> {
        return this.httpClient.get<any>(
            `${API_BASE_URL}/api/simulacions/sendEmail/${id}`,
            { observe: 'response', responseType: 'text' as 'json' }
        );
    }

    saveSimulacion(simulacion: ISimulacionDTO): Observable<HttpResponse<ISimulacion>> {
        return this.httpClient.post<ISimulacion>(
            `${API_BASE_URL}/api/simulacions/saveSimulacion`,
            simulacion,
            { observe: 'response' }
        );
    }
}
